import { Gtm } from '@/domains/core/tracking/utils/Gtm';

export const trackClickOnZoomModal = (title?: string) => {
  Gtm.push({
    event: 'interaction_click on product picture',
    event_trigger: title,
    e_category: 'navigation',
    e_action: 'Click on product picture',
    e_label: title,
    amp_event_name: 'Click on product picture',
    interaction_hit: false,
  });
};

export type CarouselNavigateInitiator =
  | 'arrow'
  | 'thumbnail'
  | 'thumb-slide'
  | 'zoomModal';
